import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import services from '@/services';
import type { DuplicateSurvey } from '@/services/surveyService';
export const useDuplicateSurveyMutation = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: async () => {
        queryClient.invalidateQueries({
          queryKey: ["surveys-infinite"]
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
async function _temp(t0) {
  const {
    surveyId,
    title
  } = t0;
  await services.survey.duplicateSurvey({
    surveyId,
    title
  });
}